import { Box, Button } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import CustomCalendarSelector from "../../../../../../../../../components/CustomCalendarSelector/CustomCalendarSelector";
import FilterSelect from "../../../../../../../../../components/FilterSelect";
import Flex from "../../../../../../../../../components/Flex";
import { FilterType, useAssessmentDateFilter } from "./useAssessmentDateFilter";

const FILTERS = [
  { value: "day", label: "Day" },
  { value: "week", label: "Week" },
  { value: "month", label: "Month" },
  { value: "year", label: "Year" },
];

interface AssessmentsToolBarProps {
  onChange?: (range: { filter: FilterType; from: Dayjs; to: Dayjs }) => void;
}
const AssessmentsToolBar = ({ onChange }: AssessmentsToolBarProps) => {
  const { filter, setFilter, selectedDate, handleChange } =
    useAssessmentDateFilter("month", dayjs(), onChange);

  return (
    <Flex
      gap={1}
      alignItems="end"
      flexDirection="row"
      mb={2.5}
      justifyContent="flex-end"
    >
      {filter === "day" && (
        <Box>
          <Button
            variant="outlined"
            onClick={() => {
              setFilter("day");
              handleChange(dayjs(new Date()));
            }}
          >
            Today
          </Button>
        </Box>
      )}
      <Box width={100}>
        <FilterSelect
          disableSortOptions
          clearable={false}
          options={FILTERS}
          value={filter}
          onChange={(val) => {
            if (val && ["day", "week", "month", "year"].includes(val)) {
              setFilter(val as FilterType);
              handleChange(selectedDate);
            }
          }}
        />
      </Box>
      <CustomCalendarSelector
        value={selectedDate}
        view={filter}
        onChange={handleChange}
        maxDate={dayjs()}
      />
    </Flex>
  );
};
export default AssessmentsToolBar;
